// ----------------------------------------------------------------------
// <copyright file="Izenda.MapFieldPropsSchema.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import CONSTANTS from 'logic/data/Izenda.ReportPartMapConstants';
import commonFieldPropsSchema from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsSchema';
import SettingsByRange from 'modules/ReportDesigner/Fields/PropertiesBuilder/CommonSettings/Izenda.SettingsByRange';
import CellColorSettings from 'modules/ReportDesigner/Fields/PropertiesBuilder/CommonSettings/Izenda.CellColorSettings';
import { remove, set, get } from 'lodash/fp';

const ContainerName = CONSTANTS.ContainerName;
const UNUSED_PROPS_FOR_POINT_OPTS = [
  'fields.dataFormattings.fields.fontFormat',
  'fields.dataFormattings.fields.fontStyle',
  'fields.dataFormattings.fields.alignment',
  'fields.dataFormattings.fields.verticalAlignment',
  'fields.dataFormattings.fields.sort',
  'fields.dataFormattings.fields.subTotal',
  'fields.dataFormattings.fields.grandTotal',
  'fields.dataFormattings.fields.width',
  'fields.dataFormattings.fields.columnWordWrap',
  'fields.headerFormating'
];

const UNUSED_PROPS_FOR_VALUES = [
  'fields.dataFormattings.fields.fontFormat',
  'fields.dataFormattings.fields.fontStyle',
  'fields.dataFormattings.fields.alignment',
  'fields.dataFormattings.fields.verticalAlignment',
  'fields.dataFormattings.fields.sort',
  'fields.dataFormattings.fields.subTotal',
  'fields.dataFormattings.fields.grandTotal',
  'fields.dataFormattings.fields.width',
  'fields.dataFormattings.fields.columnWordWrap',
  'fields.dataFormattings.fields.customURL',
  'fields.dataFormattings.fields.embeddedJavascript',
  'fields.headerFormating',
  'fields.drillDown.fields.subReport'
];

export default function(editorComp, reportDesignerModel, fieldStore, itemProps) {
  const configField = itemProps.configField || {}; // ReportPartElement
  const configReportPart = reportDesignerModel.configReportPart;
  const reportPartContent = configReportPart.reportPartContent;
  const fieldContainerDetails = itemProps.fieldContainerDetails || {};

  const containerName = fieldContainerDetails.name || '';
  let isPointOptionField = false,
    isValueField = false;

  if (CONSTANTS.PointOptionsContainers.indexOf(containerName) > -1) {
    isPointOptionField = true;
  } else if (CONSTANTS.ValuesContainers.indexOf(containerName) > -1) {
    isValueField = true;
  }

  let chartFieldPropsSchema = commonFieldPropsSchema.apply(null, arguments);
  let mappingSource = chartFieldPropsSchema.mappingSource;
  let mappingProps = chartFieldPropsSchema.mappingProps;

  // update style options of subreport
  mappingProps.stypeOptions = remove({ value: 'embedded' }, mappingProps.stypeOptions);

  // update schema
  chartFieldPropsSchema.definedSchema = updateSchema(chartFieldPropsSchema.definedSchema);

  // data formatting: show text/cell color based on container
  showTextCellColor(chartFieldPropsSchema.definedSchema);

  return chartFieldPropsSchema;

  /**
   * Remove unsed-properties
   * @param  {object} fieldSchema
   * @return {object}
   */
  function updateSchema(fieldSchema) {
    let updatedFieldSchema = fieldSchema;
    let unusedFields = [];

    if (isPointOptionField) {
      unusedFields = UNUSED_PROPS_FOR_POINT_OPTS;
    } else if (isValueField) {
      unusedFields = UNUSED_PROPS_FOR_VALUES;
    }

    // remove common-unused-fields
    unusedFields.forEach(pathItem => {
      updatedFieldSchema = set([pathItem, 'isHidden'].join('.'), true, updatedFieldSchema);
    });

    return updatedFieldSchema;
  }

  function showTextCellColor(definedSchema) {
    const colorDef = get('fields.dataFormattings.fields.color', definedSchema);

    if (!colorDef) {
      return;
    }

    const textCellSettings = {
      showTextColor: isPointOptionField,
      showCellColor: isPointOptionField || isValueField
    };
    // Add map cell color setting into the schema
    $izenda.extend(
      true,
      colorDef,
    {
        staticProps: {
          cellComponent: isPointOptionField ? SettingsByRange : CellColorSettings,
          configReportPart: configReportPart,
          configField: configField,
          reportPartContent: reportPartContent,
          containerName: containerName,
          fieldStore: fieldStore,
          maxColor: 'rgb(217,228,251)',
          minColor: 'rgb(79,134,189)',
          useThresholds: true, // if this property is true - the static/dynamic thresholds properties will be available.
          canMove: false
        }
      },
      {
        props: {
          showTextColor: textCellSettings.showTextColor,
          showCellColor: textCellSettings.showCellColor,
          pointOptionList: reportPartContent.pointOptionsList,
          isBubbleContainer: containerName === ContainerName.BUBBLE_VALUES
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartMap/Izenda.MapFieldPropsSchema.js